module.exports = __webpack_public_path__ + "img/header-engagementRingsExclusive@2x.9392031.jpg";